import { createElement } from 'react';
import { createSvg } from './createSvg.js';
import '@vebox/etui-system';
import '@vebox/etui-system-elements';

const CaseEvaporatorGlyph = /*#__PURE__*/createElement("g", {
  id: "case_evaporator"
}, /*#__PURE__*/createElement("path", {
  d: "M25.39 18.98h-5.05c-.55 0-1-.45-1-1v-2.5c0-.55.45-1 1-1h5.05c.55 0 1 .45 1 1v2.5c0 .55-.45 1-1 1zM26.37 67h4.84v2.52h-4.84zm26.32 0h4.84v2.52h-4.84zm-31-11.69h41.03v9.03H21.69z"
}), /*#__PURE__*/createElement("path", {
  d: "M62.7 55.7l-3-.04c0-.26.1-26.22-19.36-34.29-9.27-3.84-15.34-3.16-15.4-3.15l-.38-2.98c.28-.04 6.84-.83 16.93 3.35C62.85 27.45 62.72 54.55 62.7 55.7z"
}), /*#__PURE__*/createElement("path", {
  d: "M34.61 32.09H20.83c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5H34.6c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.49 1.5zm11.06 12.86H20.83c-.83 0-1.5-.67-1.5-1.5s.67-1.5 1.5-1.5h24.84c.83 0 1.5.67 1.5 1.5s-.67 1.5-1.5 1.5z"
}), /*#__PURE__*/createElement("path", {
  d: "M61.17 67.33H22.83c-1.93 0-3.5-1.57-3.5-3.5v-47.1h3v47.1c0 .28.22.5.5.5h38.33c.28 0 .5-.22.5-.5v-8.51h3v8.51c.01 1.92-1.56 3.5-3.49 3.5z"
}));
const CaseEvaporator = createSvg({
  name: 'case_evaporator',
  path: CaseEvaporatorGlyph
});

export default CaseEvaporator;
export { CaseEvaporatorGlyph };
